module.exports = __webpack_public_path__ + "static/media/ic_invest_nps.2cdb06b3.svg";